<template>
    <div class="flex time-address">
        <div class="flex time" v-if="startTime">
            <!--<i class="icon"></i>-->
            <van-icon name="clock-o" class="icon" />
            <span class="icon-text">{{startTime | formatTime}} - {{endTime | formatTime}}</span>
        </div>
        <div class="flex address" v-if="isShowAddress && address">
            <i class="icon"></i>
            <!--<van-icon name="location-o" class="icon" />-->
            <span class="icon-text">{{address}}</span>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import {Icon} from 'vant';
  Vue.use(Icon)
    export default {
        name: "TimeAddress",
        props: {
            startTime: "",
            endTime: "",
            address: "",
            isShowAddress: {
                default: true
            }
        },
        filters: {
            formatTime: function (value) {
                let d = new Date(value * 1000);
                let hours = d.getHours();
                let minutes = d.getMinutes();
                if (minutes < 10) {
                    minutes = '0' + minutes
                }
                if (hours < 10) {
                    hours = '0' + hours
                }
                return hours + ':' + minutes
            },
        }
    }
</script>

<style scoped lang="scss">
    .flex {
        align-items: center;
        font-size: 14px;
        color: #aaaaaa;

        .icon {
            display: block;
            background-size: contain;
            background-position: 0 0;
            background-repeat: no-repeat;
            margin-right: 6px;
        }

        /*.time {*/
            /*.icon {*/
                /*!*width: 14px;*!*/
                /*!*height: 14px;*!*/
                /*!*background-image: url("../assets/images/agenda/icon-wap-time.png");*!*/
            /*}*/
        /*}*/

        .address {
            margin-left: 66px;

            .icon {
                font-size: 16px;
                width: 13px;
                height: 16px;
                background-image: url("../assets/images/agenda/icon-wap-address.png");
            }
        }
    }

    //wap 样式
    @media screen and (max-width: 750px) {
        .flex {
            font-size: .24rem;
            align-items: inherit;
            .icon {
                /*<!--margin-top: -0.04rem;-->*/
                vertical-align: middle;
                margin-right: .08rem;
                color: #888888;
            }
            .icon-text{
                display: inline-block;
                vertical-align: middle;
            }
            .time {
                .icon {
                    /*font-size: .22rem;*/
                    /*width: .22rem;*/
                    /*height: .22rem;*/
                    /*width: 14px;*/
                    /*height: 14px;*/
                    /*background-image: url("../assets/images/agenda/icon-time.png");*/
                }
            }

            .address {
                margin-left: .74rem;
                .icon {
                    width: .26rem;
                    /*height: .24rem;*/
                    /*width: 12px;*/
                    /*height: 15px;*/
                    background-image: url("../assets/images/agenda/icon-address.png");
                }
            }
        }
    }
</style>
